function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});






/* =========================================================
   HERE & ALWAYS — Wrapped Gift App Popup Enhancer
   Structural refinements for Wrapped gift modal
   Place in global theme JS, not CSS
   ========================================================= */

(function () {
  const WRAPPED_UUID = "dfceaa23-b6a0-4539-9041-80da091ad5f0";
  const HOST_SELECTOR = `wrapped-gift-block[uuid="${WRAPPED_UUID}"]`;
  const STYLE_ID = "ha-wrapped-popup-enhancer-style";

  function cleanLabel(text) {
    return String(text || "")
      .replace(/\s+/g, " ")
      .replace(/\s*-\s*\$/g, " $")
      .trim();
  }

  function injectStyle(root) {
    if (!root || root.querySelector?.(`#${STYLE_ID}`)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      /* Hide only the header title, keep close X */
      gift-dialog-header h1,
      gift-dialog-header h1 span {
        color: transparent !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      gift-dialog-header {
        display: flex !important;
        justify-content: flex-end !important;
        align-items: flex-start !important;
        padding: 14px 18px 0 !important;
        background: #faf9f6 !important;
        border-bottom: 0 !important;
      }

      gift-dialog-header button,
      gift-dialog-header #close-button {
        margin: 0 !important;
      }

      /* Desktop only: vertically center the active gift fields */
      @media screen and (min-width: 769px) {
        section#content {
          justify-content: center !important;
          padding-top: 24px !important;
          padding-bottom: 24px !important;
        }

        .ha-wrap-variant-options {
          margin-bottom: 16px !important;
        }

        gift-dialog-message {
          flex: 0 0 auto !important;
        }

        .option-group:has(#message-input) {
          margin-bottom: 0 !important;
        }
      }

      /* Hide product title/price header inside modal */
      .gift-product-header {
        display: none !important;
      }

      /* Tighten product wrapper once header is hidden */
      .gift-product {
        gap: 0 !important;
        padding: 0 !important;
        border: 0 !important;
      }

      /* Description moved above Save */
      .ha-wrap-policy-note {
        order: -1 !important;
        width: 100% !important;
        margin: 0 0 8px !important;
        padding: 0 !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        color: rgba(0, 0, 0, 0.58) !important;
        font-family: "Bicyclette", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
        font-size: 11px !important;
        line-height: 1.35 !important;
        letter-spacing: 0.025em !important;
        font-weight: 400 !important;
      }

      .ha-wrap-policy-note p {
        margin: 0 !important;
        color: rgba(0, 0, 0, 0.58) !important;
        font-size: 11px !important;
        line-height: 1.35 !important;
        letter-spacing: 0.025em !important;
      }

      .ha-wrap-policy-note em {
        font-style: normal !important;
      }

      /* Hide native variant dropdown once faux option buttons are created */
      shopify-variant-selector.ha-wrap-native-variant-hidden {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        min-width: 1px !important;
        min-height: 1px !important;
        overflow: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        clip-path: inset(50%) !important;
        white-space: nowrap !important;
      }

      /* Personalizer-style exposed variant buttons */
      .ha-wrap-variant-options {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 8px !important;
        width: 100% !important;
        margin: 0 0 14px !important;
        padding: 0 0 10px !important;
      }

      .ha-wrap-variant-option {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        min-height: 34px !important;
        padding: 0 12px !important;
        margin: 0 !important;

        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18) inset !important;

        color: rgba(0, 0, 0, 0.55) !important;
        font-family: "Bicyclette", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
        font-size: 10px !important;
        line-height: 1 !important;
        letter-spacing: 0.08em !important;
        text-transform: uppercase !important;
        font-weight: 400 !important;

        cursor: pointer !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      .ha-wrap-variant-option:hover {
        color: #111111 !important;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35) inset !important;
      }

      .ha-wrap-variant-option.is-selected {
        position: relative !important;
        z-index: 5 !important;
        color: #111111 !important;
        box-shadow: 0 0 0 1.25px #111111 inset !important;
      }

      .ha-wrap-variant-option:focus-visible {
        outline: 1px solid #111111 !important;
        outline-offset: 3px !important;
      }

      /* Notecard label + counter on one row */
      .ha-wrap-label-row {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 12px !important;
        width: 100% !important;
        margin: 0 0 10px !important;
        padding: 0 !important;
      }

      .ha-wrap-label-row label {
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.82) !important;
        font-family: "Bicyclette", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
        font-size: 12px !important;
        line-height: 1 !important;
        letter-spacing: 0.075em !important;
        text-transform: uppercase !important;
        font-weight: 400 !important;
      }

      .ha-wrap-label-row .counter {
        flex: 0 0 auto !important;
        margin: 0 !important;
        padding: 0 !important;
        text-align: right !important;
        color: rgba(0, 0, 0, 0.45) !important;
        font-family: "Bicyclette", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
        font-size: 10px !important;
        line-height: 1 !important;
        letter-spacing: 0.04em !important;
        text-transform: uppercase !important;
        font-weight: 400 !important;
      }

      /* Keep the textarea spacing clean now that counter moved */
      .option-group:has(#message-input) {
        gap: 0 !important;
      }

      textarea#message-input.message-field {
        margin: 0 !important;
      }

      @media screen and (max-width: 768px) {
        .ha-wrap-variant-options {
          gap: 7px !important;
          margin-bottom: 13px !important;
        }

        .ha-wrap-variant-option {
          min-height: 34px !important;
          padding: 0 10px !important;
          font-size: 10px !important;
        }

        .ha-wrap-policy-note {
          padding: 12px 13px !important;
          font-size: 11px !important;
        }
      }
    `;

    root.appendChild(style);
  }

  function getWrappedRoot(host) {
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function getVariantSelect(variantComponent) {
    if (!variantComponent) return null;

    return (
      variantComponent.querySelector?.("select") ||
      variantComponent.shadowRoot?.querySelector?.("select") ||
      null
    );
  }

  function dispatchNativeChange(select) {
  /*
    Wrapped's current gift-variant-selector listens to the native select.
    Keep the synthetic event inside its Shadow DOM rather than allowing it
    to escape into Shopify's core event layer.
  */
  select.dispatchEvent(
    new Event("change", {
      bubbles: true
    })
  );
}

  function enhanceVariantSelector(root) {
    const variantComponent = root.querySelector("shopify-variant-selector");
    if (!variantComponent) return;

    const select = getVariantSelect(variantComponent);
    if (!select) return;

    let group = root.querySelector(".ha-wrap-variant-options");

    if (!group) {
      group = document.createElement("div");
      group.className = "ha-wrap-variant-options";
      group.setAttribute("role", "radiogroup");
      group.setAttribute("aria-label", "Gift packaging option");

      Array.from(select.options).forEach((option) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "ha-wrap-variant-option";
        button.dataset.value = option.value;
        button.setAttribute("role", "radio");
        button.textContent = cleanLabel(option.textContent);

        button.addEventListener("click", function () {
          select.value = option.value;
          dispatchNativeChange(select);
          syncVariantButtons(root);
        });

        group.appendChild(button);
      });

      variantComponent.insertAdjacentElement("beforebegin", group);
      variantComponent.classList.add("ha-wrap-native-variant-hidden");
    }

    syncVariantButtons(root);

    if (!select.dataset.haWrappedVariantListener) {
      select.dataset.haWrappedVariantListener = "true";
      select.addEventListener("change", function () {
        syncVariantButtons(root);
      });
    }
  }

  function syncVariantButtons(root) {
    const variantComponent = root.querySelector("shopify-variant-selector");
    const select = getVariantSelect(variantComponent);
    const group = root.querySelector(".ha-wrap-variant-options");

    if (!select || !group) return;

    group.querySelectorAll(".ha-wrap-variant-option").forEach((button) => {
      const isSelected = button.dataset.value === select.value;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-checked", isSelected ? "true" : "false");
    });
  }

  function moveDescriptionAboveSave(root) {
    const actions = root.querySelector("gift-dialog-actions");
    const description = root.querySelector(".gift-product-description");

    if (!actions || !description) return;

    if (!description.classList.contains("ha-wrap-policy-note")) {
      description.classList.add("ha-wrap-policy-note");
      actions.insertBefore(description, actions.firstChild);
    }
  }

  function moveCounterToLabelRow(root) {
    const textarea = root.querySelector("#message-input");
    if (!textarea) return;

    const optionGroup = textarea.closest(".option-group");
    if (!optionGroup) return;

    const label = optionGroup.querySelector('label[for="message-input"]');
    const counter = optionGroup.querySelector(".counter");

    if (!label || !counter || optionGroup.querySelector(".ha-wrap-label-row")) return;

    const row = document.createElement("div");
    row.className = "ha-wrap-label-row";

    optionGroup.insertBefore(row, label);
    row.appendChild(label);
    row.appendChild(counter);
  }

  function enhanceHost(host) {
    const root = getWrappedRoot(host);
    if (!root) return;

    injectStyle(root);
    moveDescriptionAboveSave(root);
    moveCounterToLabelRow(root);
    enhanceVariantSelector(root);
  }

  function runEnhancer() {
    document.querySelectorAll(HOST_SELECTOR).forEach(enhanceHost);
  }

  // Initial pass
  runEnhancer();

  // Re-run when cart/modal content rerenders
  const observer = new MutationObserver(function () {
    runEnhancer();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Re-run shortly after user interactions, because cart apps often render after click
  document.addEventListener(
    "click",
    function () {
      window.setTimeout(runEnhancer, 80);
      window.setTimeout(runEnhancer, 250);
      window.setTimeout(runEnhancer, 600);
    },
    true
  );
})();

/* =========================================================
   HERE & ALWAYS — Wrapped Gift App
   Gift Packaging Eligibility Logic — Stable Rehydration v8

   Behavior:
   1) Matchbox-only cart / matchbox + refill kit only:
      show Wrapped button, show ONLY the small/gift-bag packaging option.

   2) Gift-box-eligible cart:
      requires at least 2 non-refill-kit units.
      show Wrapped button, show ONLY Gift Box.

   3) Set/Duo cart:
      any non-refill item with standalone SET or DUO in its product naming
      counts as 2 gift-box-eligible units.

   4) Everything else:
      hide Wrapped button entirely.

   Wrapped variant mapping:
      Variant index 0 = small/gift-bag packaging option.
      Variant index 1 = gift-box packaging option.
      Variant names can change as long as this order stays the same.

   Refresh fix:
   If Wrapped's app config exists but the wrapped-gift-block host fails
   to remount after page refresh, manually mount the host with its required
   Wrapped option object AND block object.

   Placement fix:
   Fallback mount inserts BEFORE Rebuy footer/subtotal/checkout.

   Clickability fix:
   Fallback host must receive host.block before connectedCallback runs.
   Without this, Wrapped renders a launcher but click does not open modal.
   ========================================================= */

(function () {
  const WRAPPED_UUID = "dfceaa23-b6a0-4539-9041-80da091ad5f0";
  const HOST_SELECTOR = `wrapped-gift-block[uuid="${WRAPPED_UUID}"]`;

  const ROOT_STYLE_ID = "ha-wrapped-gift-eligibility-root-style";
  const SHADOW_STYLE_ID = "ha-wrapped-gift-eligibility-shadow-style";
  const MODE_ATTR = "data-ha-wrap-packaging-mode";
  const STORAGE_KEY = "haWrappedGiftPackagingMode";

  /*
    Wrapped variant order mapping.
    This is intentionally order-based so variant names can be changed in Shopify.
    Keep Wrapped product variants in this order:
      0 = small/gift-bag packaging option
      1 = gift-box packaging option
  */
  const SMALL_PACKAGING_OPTION_INDEX = 0;
  const GIFT_BOX_OPTION_INDEX = 1;

  /*
    Refill Kit product ID from your Easy Subscription setup.
    Add exact Matchbox product IDs/handles below only if title/handle detection fails.
  */
  const MATCHBOX_PRODUCT_IDS = [
    // Example: 1234567890
  ];

  const MATCHBOX_PRODUCT_HANDLES = [
    // Example: "the-matchbox"
  ];

  const REFILL_KIT_PRODUCT_IDS = [8788271268022];

  const REFILL_KIT_HANDLES = [
    // Example: "matchbox-refill-kit"
  ];

  const GIFT_WRAP_PRODUCT_HANDLES = [
    "wrapped-gift-blocks-gifting-for-orders"
  ];

  let currentMode = null;
  let cartCheckTimer = null;
  let cartCheckInFlight = false;
  let cartCheckQueued = false;

  function normalize(value) {
    return String(value || "").toLowerCase().trim();
  }

  function getQuantity(item) {
    const quantity = Number(item?.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getItemText(item) {
    return [
      item.handle,
      item.title,
      item.product_title,
      item.variant_title,
      item.product_type,
      item.vendor
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }

  function isGiftWrapItem(item) {
    const handle = normalize(item.handle);
    const text = getItemText(item);

    return (
      GIFT_WRAP_PRODUCT_HANDLES.includes(handle) ||
      /gift wrapping|gift wrap|gift box|gift bag/.test(text)
    );
  }

  function isRefillKitItem(item) {
    const productId = Number(item.product_id);
    const handle = normalize(item.handle);
    const text = getItemText(item);

    return (
      REFILL_KIT_PRODUCT_IDS.includes(productId) ||
      REFILL_KIT_HANDLES.includes(handle) ||
      /matchbox.*refill|refill.*matchbox|refill kit/.test(text)
    );
  }

  function isMatchboxItem(item) {
    const productId = Number(item.product_id);
    const handle = normalize(item.handle);
    const text = getItemText(item);

    if (MATCHBOX_PRODUCT_IDS.includes(productId)) return true;
    if (MATCHBOX_PRODUCT_HANDLES.includes(handle)) return true;

    return (
      /matchbox/.test(text) &&
      !isRefillKitItem(item) &&
      !isGiftWrapItem(item)
    );
  }

  function isGiftBoxSetOrDuoItem(item) {
    if (isRefillKitItem(item) || isGiftWrapItem(item)) return false;

    const text = getItemText(item);

    /*
      This intentionally looks for standalone SET or DUO only.
      It will match:
      - "California Set"
      - "The Candle Duo"
      - "california-set"
      - "candle-duo"

      It will not match:
      - "reset"
      - "duotone"
      - "settings"
    */
    return /(^|[^a-z0-9])(set|duo)(?=$|[^a-z0-9])/.test(text);
  }

  function getPackagingMode(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    /*
      Ignore Wrapped gift wrapping itself if already added.
      Otherwise, selecting gift wrapping would change eligibility.
    */
    const realItems = items.filter((item) => !isGiftWrapItem(item));

    if (!realItems.length) return "none";

    const hasMatchbox = realItems.some(isMatchboxItem);

    const onlyMatchboxRelated = realItems.every((item) => {
      return isMatchboxItem(item) || isRefillKitItem(item);
    });

    /*
      Matchbox rule:
      Matchbox-only carts, including refill kits, get the small/gift-bag packaging option only.
    */
    if (hasMatchbox && onlyMatchboxRelated) {
      return "matchbox";
    }

    /*
      Gift Box rule:
      Gift box requires at least 2 physical units that are NOT refill kits.

      Additional SET/DUO rule:
      Any non-refill item with standalone SET or DUO in its naming counts as 2 units,
      because it represents a multi-object gift even if Shopify sees it as 1 cart line.
    */
    const giftBoxEligibleUnitCount = realItems.reduce((count, item) => {
      if (isRefillKitItem(item)) return count;

      if (isGiftBoxSetOrDuoItem(item)) {
        return count + getQuantity(item) * 2;
      }

      return count + getQuantity(item);
    }, 0);

    if (giftBoxEligibleUnitCount >= 2) {
      return "giftbox";
    }

    return "none";
  }

  function injectRootStyle() {
    if (document.getElementById(ROOT_STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = ROOT_STYLE_ID;
    style.textContent = `
      html body wrapped-gift-block[uuid="${WRAPPED_UUID}"] {
        display: none !important;
      }

      html body wrapped-gift-block[uuid="${WRAPPED_UUID}"][data-ha-wrap-packaging-mode="matchbox"],
      html body wrapped-gift-block[uuid="${WRAPPED_UUID}"][data-ha-wrap-packaging-mode="giftbox"] {
        display: block !important;
      }

      html body wrapped-gift-block[uuid="${WRAPPED_UUID}"][data-ha-wrap-packaging-mode="none"] {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getWrappedRoot(host) {
    return host?.shadowRoot || host || null;
  }

  function getVariantComponent(root) {
  if (!root) return null;

  return (
    root.querySelector?.("gift-variant-selector") ||
    root.querySelector?.("shopify-variant-selector") ||
    null
  );
}

  function getVariantSelect(variantComponent) {
    if (!variantComponent) return null;

    return (
      variantComponent.querySelector?.("select") ||
      variantComponent.shadowRoot?.querySelector?.("select") ||
      null
    );
  }

  function dispatchNativeChange(select) {
  /*
    Wrapped's current gift-variant-selector listens to the native select.
    Keep the synthetic event inside its Shadow DOM rather than allowing it
    to escape into Shopify's core event layer.
  */
  select.dispatchEvent(
    new Event("change", {
      bubbles: true
    })
  );
}

  function injectShadowStyle(root) {
    if (!root || root.querySelector?.(`#${SHADOW_STYLE_ID}`)) return;

    const style = document.createElement("style");
    style.id = SHADOW_STYLE_ID;
    style.textContent = `
  .ha-wrap-variant-option.ha-wrap-option-hidden {
    display: none !important;
  }

  option.ha-wrap-option-hidden {
    display: none !important;
  }

  .ha-wrap-policy-note.ha-wrap-policy-note-hidden,
  .gift-product-description.ha-wrap-policy-note-hidden {
    display: none !important;
  }
`;

    root.appendChild(style);
  }

  function getPackagingOptions(select) {
    const options = Array.from(select.options || []);

    /*
      Name-safe mapping:
      This uses variant order, not variant names.
      Variant index 0 = small/gift-bag packaging option.
      Variant index 1 = gift-box packaging option.
    */
    const smallPackagingOption =
      options[SMALL_PACKAGING_OPTION_INDEX] ||
      options.find((option) => option !== options[GIFT_BOX_OPTION_INDEX]) ||
      options[0] ||
      null;

    const giftBoxOption =
      options[GIFT_BOX_OPTION_INDEX] ||
      options.find((option) => option !== smallPackagingOption) ||
      options[0] ||
      null;

    return {
      smallPackagingOption,
      giftBoxOption,
      matchboxOption: smallPackagingOption
    };
  }

  function closeOpenModal(root) {
    const dialog = root?.querySelector?.("dialog[open]");
    if (!dialog) return;

    try {
      if (typeof dialog.close === "function") {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
      }
    } catch (error) {
      dialog.removeAttribute("open");
    }
  }

  function syncVariantOptionVisibility(
  root,
  mode,
  select,
  giftBoxOption,
  matchboxOption
) {
  if (!root) return;

  /*
    NEW WRAPPED UI:
    Wrapped now renders gift-variant-selector with its own Shadow DOM
    containing a native <select>.

    Hide + disable the packaging option that is not permitted.
  */
  const giftVariantSelector =
    root.querySelector?.("gift-variant-selector") || null;

  const giftVariantRoot =
    giftVariantSelector?.shadowRoot ||
    giftVariantSelector ||
    null;

    /*
  H&A controls packaging eligibility.
  Because only one packaging option is ever permitted at a time,
  customers should not see or change Wrapped's variant selector.
*/
if (giftVariantSelector) {
  giftVariantSelector.hidden =
    mode === "matchbox" || mode === "giftbox";
}

  if (giftVariantRoot) {
    injectShadowStyle(giftVariantRoot);
  }

  if (select) {
    Array.from(select.options || []).forEach((option) => {
      const isGiftBoxOption =
        option.value === giftBoxOption?.value;

      const isSmallPackagingOption =
        option.value === matchboxOption?.value;

      const shouldHide =
        mode === "matchbox"
          ? isGiftBoxOption
          : mode === "giftbox"
            ? isSmallPackagingOption
            : false;

      option.hidden = shouldHide;
      option.disabled = shouldHide;
      option.classList.toggle(
        "ha-wrap-option-hidden",
        shouldHide
      );
    });
  }

  /*
    LEGACY WRAPPED UI:
    Keep support for the previous faux-button implementation in case
    Wrapped temporarily serves an older bundle or another context
    still uses the old renderer.
  */
  root
    .querySelectorAll(".ha-wrap-variant-option")
    .forEach((button) => {
      const buttonValue = button.dataset.value;

      const isGiftBoxButton =
        buttonValue === giftBoxOption?.value;

      const isSmallPackagingButton =
        buttonValue === matchboxOption?.value;

      const shouldHide =
        mode === "matchbox"
          ? isGiftBoxButton
          : mode === "giftbox"
            ? isSmallPackagingButton
            : true;

      button.classList.toggle(
        "ha-wrap-option-hidden",
        shouldHide
      );

      button.setAttribute(
        "aria-hidden",
        shouldHide ? "true" : "false"
      );

      if (shouldHide) {
        button.setAttribute("tabindex", "-1");
      } else {
        button.removeAttribute("tabindex");
      }

      const isSelected =
        select &&
        button.dataset.value === select.value;

      button.classList.toggle(
        "is-selected",
        Boolean(isSelected)
      );

      button.setAttribute(
        "aria-checked",
        isSelected ? "true" : "false"
      );
    });
}

  function syncPolicyNoteVisibility(root, mode) {
    if (!root) return;

    /*
      Keep existing behavior:
      Hide the policy note for matchbox/small-packaging mode.
      Show it for gift-box mode.
    */
    const shouldHide = mode === "matchbox";

    const policyNotes = root.querySelectorAll(
      "gift-dialog-actions .ha-wrap-policy-note, gift-dialog-actions .gift-product-description"
    );

    policyNotes.forEach((policyNote) => {
      policyNote.classList.toggle("ha-wrap-policy-note-hidden", shouldHide);
      policyNote.setAttribute("aria-hidden", shouldHide ? "true" : "false");
    });
  }

  function applyModeToHost(host, mode) {
    if (!host || !mode) return;

    /*
      Critical:
      Apply visibility mode to the host immediately.
      This allows CSS to reveal/hide the launcher even before Wrapped internals hydrate.
    */
    if (host.getAttribute(MODE_ATTR) !== mode) {
      host.setAttribute(MODE_ATTR, mode);
    }

    const root = getWrappedRoot(host);
    if (!root) return;

    injectShadowStyle(root);
    syncPolicyNoteVisibility(root, mode);

    if (mode === "none") {
      closeOpenModal(root);
      syncVariantOptionVisibility(root, mode, null, null, null);
      syncPolicyNoteVisibility(root, mode);
      return;
    }

    const variantComponent = getVariantComponent(root);
    const select = getVariantSelect(variantComponent);

    /*
      Important:
      Do not return before setting the host attribute.
      If the selector is not ready, the launcher can still show,
      and later passes will sync the hidden option.
    */
    if (!variantComponent || !select) return;

    const { giftBoxOption, matchboxOption } = getPackagingOptions(select);

    const desiredOption =
  mode === "matchbox" ? matchboxOption : giftBoxOption;

/*
  A variant may have been hidden/disabled by the previous cart mode.
  Restore the desired option before asking Wrapped to select it.
*/
if (desiredOption) {
  desiredOption.hidden = false;
  desiredOption.disabled = false;
  desiredOption.classList.remove("ha-wrap-option-hidden");
}

if (desiredOption && select.value !== desiredOption.value) {
  select.value = desiredOption.value;
  dispatchNativeChange(select);
}

syncVariantOptionVisibility(
  root,
  mode,
  select,
  giftBoxOption,
  matchboxOption
);
    syncPolicyNoteVisibility(root, mode);
  }

  function applyModeToAllHosts(mode) {
    if (!mode) return;

    injectRootStyle();

    document.querySelectorAll(HOST_SELECTOR).forEach((host) => {
      applyModeToHost(host, mode);
    });
  }

  function getWrappedOrderOption() {
    const options = window.Wrapped?.options || {};

    return (
      options.order ||
      Object.values(options).find((candidate) => {
        return candidate?.settings && candidate?.settings?.optionMode;
      }) ||
      null
    );
  }

  function getWrappedOrderBlock(option) {
    if (!option?.blocks?.length) return null;

    return (
      option.blocks.find((block) => block?.id === WRAPPED_UUID) ||
      option.blocks.find((block) => block?.blockType === "cart_drawer") ||
      option.blocks[0] ||
      null
    );
  }

  function createWrappedFallbackHost(option, block, mode) {
    const host = document.createElement("wrapped-gift-block");

    /*
      Critical:
      Wrapped requires BOTH JS properties before connectedCallback runs.
      Without option, Wrapped throws option/settings errors.
      Without block, Wrapped renders the launcher but the click does not open the modal.
    */
    host.option = option;
    host.block = block;

    host.setAttribute("uuid", WRAPPED_UUID);
    host.setAttribute(MODE_ATTR, mode);

    return host;
  }

  function repairExistingWrappedFallbackHost(existingHost, option, block, mode) {
    if (!existingHost || !option || !block) return false;

    const fallbackMount = existingHost.closest("[data-ha-wrapped-fallback-mount]");
    if (!fallbackMount) return false;

    /*
      If an older fallback host was mounted without host.block, connectedCallback
      may already have failed. Replacing the host is safer than assigning block late.
    */
    const needsRepair = !existingHost.option || !existingHost.block;

    if (!needsRepair) return false;

    const replacementHost = createWrappedFallbackHost(option, block, mode);
    fallbackMount.replaceChildren(replacementHost);

    return true;
  }

  function findWrappedMountTarget() {
    /*
      Correct placement:
      Insert fallback Wrapped block before Rebuy footer so it appears
      above subtotal / checkout.
    */
    const footer = document.querySelector('[data-rebuy-cart-anchor="footer"]');

    if (!footer?.parentElement) return null;

    return {
      parent: footer.parentElement,
      before: footer
    };
  }

  function removeWrappedFallbackMount() {
    document
      .querySelectorAll("[data-ha-wrapped-fallback-mount]")
      .forEach((mount) => mount.remove());
  }

  function ensureWrappedHostMounted(mode) {
    /*
      Only mount Wrapped when the cart is actually eligible.
      If the cart is not eligible, remove our fallback mount.
    */
    if (!["matchbox", "giftbox"].includes(mode)) {
      removeWrappedFallbackMount();
      return;
    }

    const option = getWrappedOrderOption();
    const block = getWrappedOrderBlock(option);

    /*
      If Wrapped already mounted itself, do not create a duplicate.
      But if our fallback exists from a previous/incomplete mount, repair it.
    */
    const existingHost = document.querySelector(HOST_SELECTOR);

    if (existingHost) {
      repairExistingWrappedFallbackHost(existingHost, option, block, mode);
      return;
    }

    /*
      The custom element must be registered, and Wrapped's app config
      must exist before we manually mount the host.
    */
    if (!customElements.get("wrapped-gift-block")) return;

    const target = findWrappedMountTarget();

    if (!option || !block || !target?.parent || !target?.before) return;

    const mount = document.createElement("div");
    mount.className = "ha-wrapped-fallback-mount";
    mount.setAttribute("data-ha-wrapped-fallback-mount", "true");

    const host = createWrappedFallbackHost(option, block, mode);

    mount.appendChild(host);

    /*
      Critical:
      Insert before Rebuy footer so the gifting button appears above
      subtotal / checkout, not underneath it.
    */
    target.parent.insertBefore(mount, target.before);
  }

  function commitMode(mode) {
    if (!["matchbox", "giftbox", "none"].includes(mode)) return;

    currentMode = mode;

    try {
      sessionStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // Storage can fail in private modes; ignore.
    }

    ensureWrappedHostMounted(mode);
    applyModeToAllHosts(mode);
  }

  function applyCachedMode() {
    if (!currentMode) return;

    ensureWrappedHostMounted(currentMode);
    applyModeToAllHosts(currentMode);
  }

  async function readCartAndApply() {
    if (cartCheckInFlight) {
      cartCheckQueued = true;
      return;
    }

    cartCheckInFlight = true;

    try {
      injectRootStyle();

      const response = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const mode = getPackagingMode(cart);

      commitMode(mode);
    } catch (error) {
      // Fail silently so the cart never breaks.
    } finally {
      cartCheckInFlight = false;

      if (cartCheckQueued) {
        cartCheckQueued = false;
        requestCartCheck(250);
      }
    }
  }

  function requestCartCheck(delay = 0) {
    /*
      This is intentionally NOT a forever-debounce.
      If a check is already scheduled or running, we queue one more pass.
      We do not keep clearing and postponing it during DOM mutation storms.
    */
    if (cartCheckTimer) {
      cartCheckQueued = true;
      return;
    }

    cartCheckTimer = window.setTimeout(function () {
      cartCheckTimer = null;
      readCartAndApply();
    }, delay);
  }

  function runHydrationPasses() {
    applyCachedMode();

    window.setTimeout(applyCachedMode, 50);
    window.setTimeout(applyCachedMode, 150);
    window.setTimeout(applyCachedMode, 350);
    window.setTimeout(applyCachedMode, 700);
    window.setTimeout(applyCachedMode, 1200);
    window.setTimeout(applyCachedMode, 2000);
  }

  /*
    Start.
  */
  injectRootStyle();

  try {
    const savedMode = sessionStorage.getItem(STORAGE_KEY);

    if (["matchbox", "giftbox", "none"].includes(savedMode)) {
      currentMode = savedMode;
      applyCachedMode();
    }
  } catch (error) {
    // Ignore storage failures.
  }

  /*
    Initial cart confirmations.
    Multiple fixed passes are intentional because cart apps hydrate asynchronously.
  */
  requestCartCheck(0);

  window.setTimeout(function () {
    requestCartCheck(250);
    runHydrationPasses();
  }, 250);

  window.setTimeout(function () {
    requestCartCheck(900);
    runHydrationPasses();
  }, 900);

  window.setTimeout(function () {
    requestCartCheck(1800);
    runHydrationPasses();
  }, 1800);

  window.setTimeout(function () {
    requestCartCheck(3200);
    runHydrationPasses();
  }, 3200);

  /*
    Re-run after page lifecycle events.
  */
  window.addEventListener("load", function () {
    runHydrationPasses();
    requestCartCheck(50);
  });

  window.addEventListener("pageshow", function () {
    runHydrationPasses();
    requestCartCheck(50);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      runHydrationPasses();
      requestCartCheck(50);
    }
  });

  /*
    Re-run after cart-open/user interactions.
  */
  ["click", "pointerup", "keyup", "touchend"].forEach((eventName) => {
    document.addEventListener(
      eventName,
      function () {
        runHydrationPasses();
        requestCartCheck(75);
      },
      true
    );
  });

  /*
    Watch for Rebuy/Wrapped remounts.
    Do NOT debounce forever here.
    First apply cached mode immediately, then ask for a cart confirmation.
  */
  const observer = new MutationObserver(function () {
    applyCachedMode();
    requestCartCheck(300);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
    Common cart/Rebuy events. Safe if they never fire.
  */
  [
    "rebuy:cart.change",
    "rebuy:cart.add",
    "rebuy:cart.remove",
    "rebuy:cart.refresh",
    "rebuy:cart.ready",
    "rebuy.ready",
    "cart:updated",
    "cart:change",
    "cart:refresh"
  ].forEach((eventName) => {
    document.addEventListener(eventName, function () {
      runHydrationPasses();
      requestCartCheck(50);
    });
  });
})();